import { toast, ToastContent, ToastOptions } from "react-toastify";

const defaultMessageExpiration = 5000;
const messageToastWidth = 320;

export const successToast = (message: string, autoClose = true) => {
  if (autoClose) {
    toast(message, { type: "success", autoClose: defaultMessageExpiration, style: { width: messageToastWidth } });
  } else {
    toast(message, { type: "success", autoClose: false, style: { width: messageToastWidth } });
  }
};

export const successToastComponent = (
  content: ToastContent,
  options?: ToastOptions
) => {
  toast(content, { autoClose: false, ...options });
};

export const errorToast = (message: string) => {
  toast(message, { type: "error", autoClose: false, style: { width: messageToastWidth } });
};
